import { QuizBuilderSteps } from '@repo/types/enums/quizBuilderSteps';
import { ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';

import QuizBuilderSettingsSaveButton from '@/components/features/quiz/quiz-builder/QuizBuilderSettingsSaveButton';
import { Button } from '@/components/ui/button';
import { useQuizBuilder } from '@/context/quiz-builder';

export default function QuizBuilderHeaderSubmitButtons() {
  const { currentStep, submitBasicInfoForm, submitSectionsForm } = useQuizBuilder();

  switch (currentStep) {
    case QuizBuilderSteps.BASIC_INFO:
      return (
        <Button variant={'primary'} onClick={submitBasicInfoForm}>
          Kontynuuj
          <ArrowRightIcon />
        </Button>
      );
    case QuizBuilderSteps.QUESTIONS:
      return (
        <Button variant={'primary'} onClick={submitSectionsForm}>
          <CheckCircle2Icon />
          Kontynuuj
        </Button>
      );
    case QuizBuilderSteps.SETTINGS:
      return <QuizBuilderSettingsSaveButton />;
  }
}
